import React, { useContext, useEffect, useState } from "react";
import { Row, Container } from "react-bootstrap";
import "../../assets/styles/Pizza.css";
import { StateContext } from "../../contexts/StateContext";
import { getIngredients } from "../../api/api-pizza.js";
import PickDough from "./PickDough";
import AddIngredients from "./AddIngredients";

const Pizza = () => {
  const { ingredients, setIngredients } = useContext(StateContext);
  const [showAddIngredients, setShowAddIngredients] = useState(false);
  const [selectedDough, setSelectedDough] = useState({});

  useEffect(() => {
    if (!ingredients) {
      getIngredients().then((result) => {
        setIngredients(result);
      });
    }
  });

  const addDough = (dough) => {
    setSelectedDough(dough);
    setShowAddIngredients(true);
  };

  const clearDough = () => {
    setSelectedDough({});
    setShowAddIngredients(false);
  };

  return (
    <Container className="pizza-box h-100 border border-dark rounded-2 pb-4">
      <Row>
        <h5 className="align-middle mt-1 text-success">Pick a Dough</h5>
        <hr className="border border-dark" />
      </Row>
      <div className="h-100 scrollable overflow-auto">
        {ingredients &&
          ingredients.dough.map((dough, i) => (
            <PickDough dough={dough} key={i} addDough={addDough} />
          ))}
      </div>
      {ingredients && showAddIngredients && (
        <AddIngredients selectedDough={selectedDough} clearDough={clearDough} />
      )}
    </Container>
  );
};

export default Pizza;
